
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "documents-public-ui",
  currentProjectVersion: "static-1.35542",
  depVersions: {
  "documents-public-ui": "static-1.35542",
  "atom": "static-1.5550",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2963",
  "client-types": "static-1.510",
  "cssUtils": "static-1.1100",
  "customer-data-filters-ui": "static-1.41369",
  "customer-data-objects": "static-1.8182",
  "customer-data-property-utils": "static-1.8528",
  "documents-lib": "static-1.35547",
  "emoji-mart": "static-3.7",
  "flux-actions": "static-1.380",
  "FormsCommonComponents": "static-1.86843",
  "FormUrlGenerator": "static-2.5190",
  "foundations-theming-specialty": "static-1.2682",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6070",
  "hs-test-utils": "static-1.8516",
  "hub-http": "static-1.6684",
  "hubspot-dlb": "static-2.1911",
  "HubStyle": "static-2.12272",
  "HubStyleTokens": "static-2.11965",
  "I18n": "static-7.1708",
  "icons": "static-2.703",
  "jasmine-immutable": "static-1.3415",
  "jasmine-runner": "static-1.6929",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7624",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3362",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5858",
  "quartz": "static-1.7660",
  "react": "static-7.202",
  "react-dlb": "static-1.93",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17215",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5658",
  "react-virtualized": "static-2.112",
  "reference-resolvers": "static-1.8661",
  "reference-resolvers-lite": "static-1.8590",
  "reporting-data": "static-1.69358",
  "reporting-reports": "static-1.69034",
  "reporting-snowflake": "static-1.57974",
  "reporting-testing-lib": "static-1.11291",
  "reporting-visualizations": "static-1.61432",
  "reselect": "static-3.16",
  "sales-content-partitioning": "static-1.9438",
  "sanitize": "static-1.4952",
  "sanitize-text": "static-1.8636",
  "SharedI18nStrings": "static-1.187",
  "SharedLegalStrings": "static-1.2207",
  "signup-constants": "static-1.19949",
  "signup-ui-url-generator": "static-2.8520",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5237",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5226",
  "ui-addon-form-validation": "static-1.11348",
  "ui-asset-management-lib": "static-1.11578",
  "ui-images": "static-2.1277",
  "UIComponents": "static-3.8911",
  "usage-tracker": "static-1.7802",
  "usage-tracker-container": "static-1.7792",
  "usage-tracker-core": "static-1.7652",
  "viral-links-lib": "static-1.7559",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.10118",
  "foundations-components": "static-1.8754",
  "immutable": "static-2.88",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1438",
  "quartz-core": "static-1.6879",
  "quick-fetch": "static-1.4233",
  "raven": "static-3.5925",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "rpc-client-utils": "static-1.5147",
  "ui-addon-i18n": "static-1.11623",
  "ui-addon-upgrades": "static-9.18547",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4383",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3937",
  "quartz-webpack": "static-1.3884",
  "foundations-assets": "static-1.5363",
  "foundations-theming": "static-1.4966",
  "hub-http-janus": "static-1.907",
  "hub-http-shared-msw-handlers": "static-1.10911",
  "hubspotter-http": "static-1.4977",
  "trellis-components": "static-1.3113",
  "trellis-migration-context": "static-1.58",
  "sassPrefix": "static-1.366",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44113",
  "customer-data-filters-ui-msw-helpers": "static-1.23804",
  "customer-data-objects-ui-components": "static-1.13513",
  "customer-data-reference-ui-components": "static-1.13653",
  "customer-data-ui-utilities": "static-1.10309",
  "events-data-lib": "static-1.723",
  "framework-builder-read-service-client": "static-1.4337",
  "hs-resources": "static-1.667",
  "immer": "static-1.105",
  "inbound-db-meta-service-client": "static-1.3776",
  "inbound-db-properties-service-client": "static-1.4153",
  "multi-account-reference-resolvers": "static-1.1487",
  "onboarding-tours": "static-1.17410",
  "pulse": "static-1.1125",
  "reporting-datasets-permissions-lib": "static-1.14777",
  "segments-client-types": "static-1.12157",
  "stylex": "static-1.46",
  "trellis-assets": "static-1.3094",
  "trellis-theming": "static-1.1483",
  "ui-addon-teams": "static-1.22014",
  "quartz-auth": "static-1.1335",
  "ui-business-units-lib": "static-1.9573",
  "usage-tracker-session-replay": "static-1.5488",
  "ai-components-ui-library": "static-1.10026",
  "ContentUtils": "static-1.69479",
  "customer-data-properties": "static-1.53060",
  "forms-ai-lib": "static-1.4989",
  "forms-utils-lib": "static-1.13343",
  "foundations-components-test-utils": "static-1.6237",
  "react-dnd-compat": "static-1.5087",
  "react-tinymce": "static-1.56276",
  "tinymce-config": "static-2.55402",
  "ui-gdpr-components": "static-1.10656",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3951",
  "HeadJS": "static-2.822",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3627",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "hs-locale-management": "static-1.402",
  "ui-fonts": "static-1.1227",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4785",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.178",
  "quartz-head": "static-1.1325",
  "web-vitals": "static-1.19",
  "batch-promise": "static-1.2026",
  "external-options-client-types": "static-1.4441",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.1335",
  "frontend-preferences-client": "static-1.8398",
  "graphql": "static-1.93",
  "persist-promise": "static-1.4183",
  "reporting-client-types": "static-1.2838",
  "apollo-stack-hubspot": "static-3.99",
  "hubspot-apollo-client": "static-1.5358",
  "foundations-components-legacy": "static-1.1779",
  "quartz-routing": "static-1.1090",
  "hs-story-utils": "static-1.9904",
  "react-flip-move": "static-1.83",
  "nested-table": "static-1.710",
  "seat-types-lib": "static-1.1059",
  "timezone-utils": "static-2.5707",
  "react-create-root-preference": "static-1.103",
  "bend-plugin-foundations-components": "static-1.5023",
  "floating-ui": "static-1.68",
  "react-aria": "static-1.77",
  "tanstack-table": "static-1.66",
  "opentelemetry-fe-types": "static-1.269",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.644",
  "quartz-test": "static-1.1335",
  "quartz-tracking": "static-1.1039",
  "bend-plugin-chirp-manifest": "static-1.557",
  "chirp-fetch": "static-1.2382",
  "merchandise-lib": "static-1.284",
  "purchase-motions-components": "static-1.6636",
  "ts-schema": "static-1.4395",
  "bender-build-tools": "static-1.3598",
  "bend-plugin-foundations-theming": "static-1.3449",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "restore-request-side-panel-lib": "static-1.2034",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.5065",
  "conditional-properties-service-client": "static-1.4115",
  "crm-pipelines-api-client-types": "static-1.4445",
  "event-emitter": "static-1.1439",
  "fdsr-migration-layer": "static-1.489",
  "multi-currency-client-types": "static-1.4009",
  "getting-started-shared-tasks": "static-1.19571",
  "growth-data-modal": "static-1.6139",
  "growth-onboarding-confetti": "static-1.3536",
  "growth-onboarding-next-action-utils": "static-1.2991",
  "navigation-components": "static-1.19173",
  "nest": "static-1.713",
  "onboarding-tours-client": "static-1.5625",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-react": "static-3.10756",
  "ui-shepherd-tracker": "static-1.8137",
  "ui-universal-auth": "static-1.9752",
  "user-context": "static-1.5531",
  "bend-plugin-pulse": "static-1.628",
  "fast-json-patch": "static-1.74",
  "crm-index-associations-lib": "static-1.6926",
  "stylex-utils": "static-1.175",
  "hubspotter-http-shared-msw-handlers": "static-1.10909",
  "magpie-lib": "static-1.5909",
  "navigation-messaging": "static-1.8500",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23903",
  "copilot-toolkit": "static-1.12156",
  "cms-field-types": "static-1.5288",
  "content-icons-ui": "static-1.2459",
  "integrations-lib": "static-1.17437",
  "calling-global-api": "static-1.66204",
  "calling-internal-common": "static-1.31803",
  "calling-lifecycle-internal": "static-1.67586",
  "calling-lifecycle-messages": "static-1.59878",
  "commerce-products-lib": "static-1.10926",
  "crm-index-visualization-core": "static-1.4762",
  "crm-links": "static-1.6788",
  "customer-data-properties-shared-msw-handlers": "static-1.10238",
  "file-manager-components": "static-1.24849",
  "formula-editor": "static-1.15017",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1109",
  "object-builder-ui-client": "static-1.50055",
  "pipeline-validation-client-types": "static-1.4283",
  "property-value-citations": "static-1.3674",
  "smart-data-capture-core": "static-1.481",
  "smart-property-lib": "static-1.8665",
  "tiered-pricing": "static-1.2285",
  "topics-actions-lib": "static-1.660",
  "trellis-ext-i18n": "static-1.1394",
  "trial-components-library": "static-1.14382",
  "ui-addon-iframeable": "static-1.9553",
  "zustand": "static-1.89",
  "final-form": "static-1.83",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.82",
  "rich-text-lib": "static-1.20561",
  "tinymce-themes": "static-1.57372",
  "data-token-picker": "static-1.17141",
  "hub-http-contrib": "static-1.3510",
  "interframe": "static-3.5219",
  "tinymce-data": "static-1.41487",
  "tinymce-plugins": "static-1.58516",
  "ui-addon-sales-email": "static-1.5679",
  "hubspot-apollo-cache": "static-1.817",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.628",
  "opentelemetry-web": "static-1.22",
  "onboarding-scopes": "static-1.6930",
  "purchase-motions-api": "static-1.6639",
  "onboarding-data-sync-lib": "static-1.2845",
  "growth-onboarding-next-action-components": "static-1.3019",
  "user-context-client": "static-1.4987",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5369",
  "reactive-lib": "static-1.1197",
  "simple-logging-lib": "static-1.3529",
  "custom-vendor-connection-lib": "static-1.316",
  "unified-auth-core-lib": "static-1.1548",
  "getting-started-shared-tasks-store": "static-1.18689",
  "nav-meta": "static-1.30810",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.2192",
  "integrations-error-boundary-lib": "static-1.14852",
  "integrations-tracking-lib": "static-1.6098",
  "native-integrations-shared-strings": "static-1.8241",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10848",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31810",
  "shared-worker-versioning": "static-1.11519",
  "calling-usage-tracker": "static-1.7017",
  "customer-data-tracking": "static-1.7348",
  "voice-sms-access-library": "static-1.2459",
  "commerce-permissions": "static-1.1262",
  "growth-payments-core": "static-1.26509",
  "products-iframe-lib": "static-1.8913",
  "products-ui-components-shared-msw-handlers": "static-1.11293",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10994",
  "sales-views-client-types": "static-1.4735",
  "framework-data-schema-resolvers": "static-1.7370",
  "location-customization-utils-lib": "static-1.10426",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4619",
  "poll-commands": "static-1.3955",
  "video-components-external": "static-1.12437",
  "video-data-lib": "static-1.36095",
  "bark-lib": "static-1.17008",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6373",
  "react-codemirror": "static-1.11119",
  "data-agent-kit": "static-1.923",
  "data-agent-test-utils": "static-1.467",
  "data-agent-utils": "static-1.936",
  "feedback-loader": "static-1.30068",
  "fsm": "static-1.4235",
  "policy-lib": "static-1.7282",
  "react-colorpicker": "static-2.10687",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11057",
  "embedded-academy-lib": "static-1.16016",
  "hubs-service-types": "static-1.1746",
  "nudge-client-utils": "static-1.3428",
  "salesImages": "static-1.735",
  "FileManagerLib": "static-1.40489",
  "NamespacedHubStyle": "static-2.9369",
  "FileManagerCore": "static-1.40348",
  "content-assistance-lib": "static-1.8428",
  "layout-dnd-components": "static-1.13235",
  "layout-dnd-utils": "static-1.12210",
  "ui-addon-emoji-picker": "static-1.10341",
  "ui-brand-identity-lib": "static-1.16956",
  "InboxConnectUtils": "static-4.15850",
  "meetings-connect-utils-lib": "static-1.8096",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1170",
  "breeze-engine-core": "static-1.1470",
  "highlight.js": "static-1.90",
  "universal-page-editor-lib": "static-1.3489",
  "calling-orchestration-schema": "static-1.37236",
  "ui-addon-opt": "static-4.8887",
  "framework-data-schema-quick-fetch": "static-1.7275",
  "crm-record-cards-service-types": "static-1.3871",
  "content-media-composition-data-lib": "static-1.13605",
  "content-media-compositions": "static-2.17612",
  "media-bridge-lib": "static-1.19649",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16676",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4976",
  "enrichment-settings-lib": "static-1.241",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15477",
  "nudge-custom-function-registry": "static-1.3185",
  "nudge-renderer-utils": "static-1.3504",
  "whisper-core-api": "static-1.7643",
  "audio-components": "static-1.6576",
  "FileManagerImages": "static-1.38000",
  "video-components": "static-1.14439",
  "breeze-artifacts-sdk": "static-1.966",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4992",
  "video-embed": "static-1.36929",
  "ui-addon-video-player": "static-1.9101",
  "ui-coaching-tips": "static-1.29586",
  "ContentData": "static-1.69554",
  "layout-data-lib": "static-1.10535",
  "academy-service-client": "static-1.4170",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4874",
  "trellis-ecosystem": "static-1.7854",
  "ui-addon-react-router-dom": "static-1.10002",
  "wootric-nps": "static-1.7298",
  "social-insights-client-types": "static-1.22938",
  "outpost": "static-1.4605",
  "growth-onboarding-feedback-components": "static-1.7058",
  "advanced-menus-core": "static-1.15822",
  "advanced-menus-lib": "static-1.12573",
  "ExportDialog": "static-6.10851",
  "ui-memberships-settings-lib": "static-1.35202",
  "marketplace-ui-apps-core": "static-1.19582",
  "marketplace-ui-common": "static-1.21050",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15821",
  "simple-menus-lib": "static-1.17338",
  "settings-ui-lib": "static-1.13005",
  "developer-experience-shared-components": "static-1.11017",
  "immutable-less": "static-1.5130",
  "marketplace-ui-client-types": "static-1.18457",
  "ui-addon-integrations-directory-panel": "static-2.8431",
  "ui-extensibility-client-types": "static-1.4393",
  "ai-settings-ui-library": "static-1.8592",
  "ui-product-approvals-common": "static-1.1588",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4615",
  "simple-data-table": "static-1.3830"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35542",
  "atom": "/atom/static-1.5550",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2963",
  "client-types": "/client-types/static-1.510",
  "cssUtils": "/cssUtils/static-1.1100",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41369",
  "customer-data-objects": "/customer-data-objects/static-1.8182",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8528",
  "documents-lib": "/documents-lib/static-1.35547",
  "emoji-mart": "/emoji-mart/static-3.7",
  "flux-actions": "/flux-actions/static-1.380",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86843",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5190",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2682",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6070",
  "hs-test-utils": "/hs-test-utils/static-1.8516",
  "hub-http": "/hub-http/static-1.6684",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyle": "/HubStyle/static-2.12272",
  "HubStyleTokens": "/HubStyleTokens/static-2.11965",
  "I18n": "/I18n/static-7.1708",
  "icons": "/icons/static-2.703",
  "jasmine-immutable": "/jasmine-immutable/static-1.3415",
  "jasmine-runner": "/jasmine-runner/static-1.6929",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7624",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3362",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5858",
  "quartz": "/quartz/static-1.7660",
  "react": "/react/static-7.202",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17215",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5658",
  "react-virtualized": "/react-virtualized/static-2.112",
  "reference-resolvers": "/reference-resolvers/static-1.8661",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8590",
  "reporting-data": "/reporting-data/static-1.69358",
  "reporting-reports": "/reporting-reports/static-1.69034",
  "reporting-snowflake": "/reporting-snowflake/static-1.57974",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11291",
  "reporting-visualizations": "/reporting-visualizations/static-1.61432",
  "reselect": "/reselect/static-3.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9438",
  "sanitize": "/sanitize/static-1.4952",
  "sanitize-text": "/sanitize-text/static-1.8636",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2207",
  "signup-constants": "/signup-constants/static-1.19949",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5237",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5226",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11578",
  "ui-images": "/ui-images/static-2.1277",
  "UIComponents": "/UIComponents/static-3.8911",
  "usage-tracker": "/usage-tracker/static-1.7802",
  "usage-tracker-container": "/usage-tracker-container/static-1.7792",
  "usage-tracker-core": "/usage-tracker-core/static-1.7652",
  "viral-links-lib": "/viral-links-lib/static-1.7559",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.10118",
  "foundations-components": "/foundations-components/static-1.8754",
  "immutable": "/immutable/static-2.88",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1438",
  "quartz-core": "/quartz-core/static-1.6879",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "rpc-client-utils": "/rpc-client-utils/static-1.5147",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11623",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3937",
  "quartz-webpack": "/quartz-webpack/static-1.3884",
  "foundations-assets": "/foundations-assets/static-1.5363",
  "foundations-theming": "/foundations-theming/static-1.4966",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10911",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "trellis-components": "/trellis-components/static-1.3113",
  "trellis-migration-context": "/trellis-migration-context/static-1.58",
  "sassPrefix": "/sassPrefix/static-1.366",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44113",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23804",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13513",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13653",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10309",
  "events-data-lib": "/events-data-lib/static-1.723",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "hs-resources": "/hs-resources/static-1.667",
  "immer": "/immer/static-1.105",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1487",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "pulse": "/pulse/static-1.1125",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14777",
  "segments-client-types": "/segments-client-types/static-1.12157",
  "stylex": "/stylex/static-1.46",
  "trellis-assets": "/trellis-assets/static-1.3094",
  "trellis-theming": "/trellis-theming/static-1.1483",
  "ui-addon-teams": "/ui-addon-teams/static-1.22014",
  "quartz-auth": "/quartz-auth/static-1.1335",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9573",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5488",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10026",
  "ContentUtils": "/ContentUtils/static-1.69479",
  "customer-data-properties": "/customer-data-properties/static-1.53060",
  "forms-ai-lib": "/forms-ai-lib/static-1.4989",
  "forms-utils-lib": "/forms-utils-lib/static-1.13343",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6237",
  "react-dnd-compat": "/react-dnd-compat/static-1.5087",
  "react-tinymce": "/react-tinymce/static-1.56276",
  "tinymce-config": "/tinymce-config/static-2.55402",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3951",
  "HeadJS": "/HeadJS/static-2.822",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3627",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "ui-fonts": "/ui-fonts/static-1.1227",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4785",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.178",
  "quartz-head": "/quartz-head/static-1.1325",
  "web-vitals": "/web-vitals/static-1.19",
  "batch-promise": "/batch-promise/static-1.2026",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.1335",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8398",
  "graphql": "/graphql/static-1.93",
  "persist-promise": "/persist-promise/static-1.4183",
  "reporting-client-types": "/reporting-client-types/static-1.2838",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5358",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1779",
  "quartz-routing": "/quartz-routing/static-1.1090",
  "hs-story-utils": "/hs-story-utils/static-1.9904",
  "react-flip-move": "/react-flip-move/static-1.83",
  "nested-table": "/nested-table/static-1.710",
  "seat-types-lib": "/seat-types-lib/static-1.1059",
  "timezone-utils": "/timezone-utils/static-2.5707",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5023",
  "floating-ui": "/floating-ui/static-1.68",
  "react-aria": "/react-aria/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.66",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.269",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.644",
  "quartz-test": "/quartz-test/static-1.1335",
  "quartz-tracking": "/quartz-tracking/static-1.1039",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.557",
  "chirp-fetch": "/chirp-fetch/static-1.2382",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "purchase-motions-components": "/purchase-motions-components/static-1.6636",
  "ts-schema": "/ts-schema/static-1.4395",
  "bender-build-tools": "/bender-build-tools/static-1.3598",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3449",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2034",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5065",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "event-emitter": "/event-emitter/static-1.1439",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.489",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19571",
  "growth-data-modal": "/growth-data-modal/static-1.6139",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3536",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2991",
  "navigation-components": "/navigation-components/static-1.19173",
  "nest": "/nest/static-1.713",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10756",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8137",
  "ui-universal-auth": "/ui-universal-auth/static-1.9752",
  "user-context": "/user-context/static-1.5531",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.628",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6926",
  "stylex-utils": "/stylex-utils/static-1.175",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10909",
  "magpie-lib": "/magpie-lib/static-1.5909",
  "navigation-messaging": "/navigation-messaging/static-1.8500",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23903",
  "copilot-toolkit": "/copilot-toolkit/static-1.12156",
  "cms-field-types": "/cms-field-types/static-1.5288",
  "content-icons-ui": "/content-icons-ui/static-1.2459",
  "integrations-lib": "/integrations-lib/static-1.17437",
  "calling-global-api": "/calling-global-api/static-1.66204",
  "calling-internal-common": "/calling-internal-common/static-1.31803",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67586",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59878",
  "commerce-products-lib": "/commerce-products-lib/static-1.10926",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4762",
  "crm-links": "/crm-links/static-1.6788",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10238",
  "file-manager-components": "/file-manager-components/static-1.24849",
  "formula-editor": "/formula-editor/static-1.15017",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1109",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50055",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4283",
  "property-value-citations": "/property-value-citations/static-1.3674",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.481",
  "smart-property-lib": "/smart-property-lib/static-1.8665",
  "tiered-pricing": "/tiered-pricing/static-1.2285",
  "topics-actions-lib": "/topics-actions-lib/static-1.660",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1394",
  "trial-components-library": "/trial-components-library/static-1.14382",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9553",
  "zustand": "/zustand/static-1.89",
  "final-form": "/final-form/static-1.83",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "rich-text-lib": "/rich-text-lib/static-1.20561",
  "tinymce-themes": "/tinymce-themes/static-1.57372",
  "data-token-picker": "/data-token-picker/static-1.17141",
  "hub-http-contrib": "/hub-http-contrib/static-1.3510",
  "interframe": "/interframe/static-3.5219",
  "tinymce-data": "/tinymce-data/static-1.41487",
  "tinymce-plugins": "/tinymce-plugins/static-1.58516",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5679",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.817",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.628",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "onboarding-scopes": "/onboarding-scopes/static-1.6930",
  "purchase-motions-api": "/purchase-motions-api/static-1.6639",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2845",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3019",
  "user-context-client": "/user-context-client/static-1.4987",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5369",
  "reactive-lib": "/reactive-lib/static-1.1197",
  "simple-logging-lib": "/simple-logging-lib/static-1.3529",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.316",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1548",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18689",
  "nav-meta": "/nav-meta/static-1.30810",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2192",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14852",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6098",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8241",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10848",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31810",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11519",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7017",
  "customer-data-tracking": "/customer-data-tracking/static-1.7348",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2459",
  "commerce-permissions": "/commerce-permissions/static-1.1262",
  "growth-payments-core": "/growth-payments-core/static-1.26509",
  "products-iframe-lib": "/products-iframe-lib/static-1.8913",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11293",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10994",
  "sales-views-client-types": "/sales-views-client-types/static-1.4735",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7370",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10426",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4619",
  "poll-commands": "/poll-commands/static-1.3955",
  "video-components-external": "/video-components-external/static-1.12437",
  "video-data-lib": "/video-data-lib/static-1.36095",
  "bark-lib": "/bark-lib/static-1.17008",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6373",
  "react-codemirror": "/react-codemirror/static-1.11119",
  "data-agent-kit": "/data-agent-kit/static-1.923",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.467",
  "data-agent-utils": "/data-agent-utils/static-1.936",
  "feedback-loader": "/feedback-loader/static-1.30068",
  "fsm": "/fsm/static-1.4235",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-colorpicker": "/react-colorpicker/static-2.10687",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11057",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16016",
  "hubs-service-types": "/hubs-service-types/static-1.1746",
  "nudge-client-utils": "/nudge-client-utils/static-1.3428",
  "salesImages": "/salesImages/static-1.735",
  "FileManagerLib": "/FileManagerLib/static-1.40489",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "FileManagerCore": "/FileManagerCore/static-1.40348",
  "content-assistance-lib": "/content-assistance-lib/static-1.8428",
  "layout-dnd-components": "/layout-dnd-components/static-1.13235",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12210",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10341",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16956",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15850",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8096",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1170",
  "breeze-engine-core": "/breeze-engine-core/static-1.1470",
  "highlight.js": "/highlight.js/static-1.90",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3489",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37236",
  "ui-addon-opt": "/ui-addon-opt/static-4.8887",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7275",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13605",
  "content-media-compositions": "/content-media-compositions/static-2.17612",
  "media-bridge-lib": "/media-bridge-lib/static-1.19649",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16676",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4976",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.241",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15477",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3185",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3504",
  "whisper-core-api": "/whisper-core-api/static-1.7643",
  "audio-components": "/audio-components/static-1.6576",
  "FileManagerImages": "/FileManagerImages/static-1.38000",
  "video-components": "/video-components/static-1.14439",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.966",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4992",
  "video-embed": "/video-embed/static-1.36929",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9101",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29586",
  "ContentData": "/ContentData/static-1.69554",
  "layout-data-lib": "/layout-data-lib/static-1.10535",
  "academy-service-client": "/academy-service-client/static-1.4170",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4874",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7854",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10002",
  "wootric-nps": "/wootric-nps/static-1.7298",
  "social-insights-client-types": "/social-insights-client-types/static-1.22938",
  "outpost": "/outpost/static-1.4605",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7058",
  "advanced-menus-core": "/advanced-menus-core/static-1.15822",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12573",
  "ExportDialog": "/ExportDialog/static-6.10851",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35202",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15821",
  "simple-menus-lib": "/simple-menus-lib/static-1.17338",
  "settings-ui-lib": "/settings-ui-lib/static-1.13005",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11017",
  "immutable-less": "/immutable-less/static-1.5130",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8431",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4393",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8592",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1588",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4615",
  "simple-data-table": "/simple-data-table/static-1.3830"
}
};
